import { render, staticRenderFns } from "./AccountProductsTab.vue?vue&type=template&id=538ea7f9&scoped=true"
import script from "./AccountProductsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountProductsTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AccountProductsTab.vue?vue&type=style&index=0&id=538ea7f9&prod&scoped=true&lang=css"
import style1 from "./AccountProductsTab.vue?vue&type=style&index=1&id=538ea7f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538ea7f9",
  null
  
)

export default component.exports